var pe = Object.defineProperty;
var he = (e, t, r) => t in e ? pe(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var T = (e, t, r) => (he(e, typeof t != "symbol" ? t + "" : t, r), r);
import { jsx as C, jsxs as I, Fragment as me } from "react/jsx-runtime";
import { createContext as ee, useRef as te, forwardRef as H, createElement as D, useEffect as ye, useState as ge, Suspense as ve } from "react";
import * as be from "@tanstack/react-query";
import { useSuspenseQuery as we, dehydrate as Ce, hydrate as _e, QueryClientProvider as Ee, QueryClient as ke } from "@tanstack/react-query";
import { I18nextProvider as xe, useTranslation as re } from "react-i18next";
import "i18next";
const Te = ({ children: e, i18nInstance: t }) => /* @__PURE__ */ C(xe, { i18n: t, children: e }), Ae = (e = "label") => {
  const t = Array.isArray(e) ? e : [e];
  return re(t);
};
var x = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Se = typeof x == "object" && x && x.Object === Object && x, Oe = typeof self == "object" && self && self.Object === Object && self;
Se || Oe || Function("return this")();
/*! js-cookie v3.0.5 | MIT */
function j(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t];
    for (var n in r)
      e[n] = r[n];
  }
  return e;
}
var Le = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function M(e, t) {
  function r(o, s, i) {
    if (!(typeof document > "u")) {
      i = j({}, t, i), typeof i.expires == "number" && (i.expires = new Date(Date.now() + i.expires * 864e5)), i.expires && (i.expires = i.expires.toUTCString()), o = encodeURIComponent(o).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";
      for (var l in i)
        i[l] && (a += "; " + l, i[l] !== !0 && (a += "=" + i[l].split(";")[0]));
      return document.cookie = o + "=" + e.write(s, o) + a;
    }
  }
  function n(o) {
    if (!(typeof document > "u" || arguments.length && !o)) {
      for (var s = document.cookie ? document.cookie.split("; ") : [], i = {}, a = 0; a < s.length; a++) {
        var l = s[a].split("="), u = l.slice(1).join("=");
        try {
          var d = decodeURIComponent(l[0]);
          if (i[d] = e.read(u, d), o === d)
            break;
        } catch {
        }
      }
      return o ? i[o] : i;
    }
  }
  return Object.create(
    {
      set: r,
      get: n,
      remove: function(o, s) {
        r(
          o,
          "",
          j({}, s, {
            expires: -1
          })
        );
      },
      withAttributes: function(o) {
        return M(this.converter, j({}, this.attributes, o));
      },
      withConverter: function(o) {
        return M(j({}, this.converter, o), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
M(Le, { path: "/" });
ee({});
function K(e) {
  return e.toLowerCase().split(" ").map(function(t) {
    return t.replace(t[0], t[0].toUpperCase());
  }).join(" ");
}
ee({
  pageUrl: ""
});
function Re({
  apiKey: e,
  clickoutOrigin: t,
  clickoutServiceUrl: r,
  deviceType: n,
  fullPageUrl: o,
  gtmId: s,
  offers: i,
  pageUrl: a,
  recommendedMarketId: l,
  shouldUseClickoutService: u
}) {
  return !u || !r ? i ?? [] : i != null && i.length ? i.map((d, g) => {
    const h = {
      apiKey: e,
      clickoutOrigin: t,
      containerId: s,
      deviceType: n,
      fullPageUrl: o,
      offerId: String(d == null ? void 0 : d.id),
      offerPosition: String(g),
      pageUrl: a,
      recommendedMarketId: l
    }, f = new URL(r), y = f.searchParams;
    for (const [p, m] of Object.entries(h))
      m != null && y.set(p, m);
    return f.search = y.toString(), {
      ...d,
      clickOutUrl: f.toString()
    };
  }) : [];
}
function N() {
  return /* @__PURE__ */ C("svg", { fill: "none", height: "11", viewBox: "0 0 7 11", width: "7", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ C("path", { d: "M1.26717 1.00004L5.53433 5.24268L1.26717 9.48532", id: "Rectangle", stroke: "currentColor", strokeWidth: "2" }) });
}
const Pe = (e) => Ie[e] || void 0, je = "container_cumqgj", Ie = {
  autohide: "autohide_ac8cxyz",
  default: "default_dxz1gvw"
}, Ue = (e) => `${je} ${Pe(e)}`, De = (e, t) => Number(window.getComputedStyle(e, null).getPropertyValue(t).replace("px", "")), Me = ({ children: e, variant: t = "default" }) => {
  const r = Ue(t), n = te(null), o = (s) => {
    if (n.current) {
      const i = n.current, a = De(i, "column-gap"), u = i.children[0].offsetWidth + a;
      s ? i.scrollLeft += u : i.scrollLeft -= u;
    }
  };
  return /* @__PURE__ */ I(me, { children: [
    /* @__PURE__ */ C("div", { className: r, ref: n, children: e }),
    /* @__PURE__ */ C("button", { "aria-label": "Scroll Left", onClick: () => o(), children: /* @__PURE__ */ C(N, {}) }),
    /* @__PURE__ */ C("button", { "aria-label": "Scroll Right", onClick: () => o(!0), children: /* @__PURE__ */ C(N, {}) })
  ] });
}, Ne = (e) => {
  if (!e)
    return "";
  const t = new URL(e);
  return t.searchParams.append("fm", "webp"), t.searchParams.append("w", "190"), t.toString();
};
function $e(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var Fe = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, U = /* @__PURE__ */ $e(
  function(e) {
    return Fe.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), qe = function() {
  const t = Array.prototype.slice.call(arguments).filter(Boolean), r = {}, n = [];
  t.forEach((s) => {
    (s ? s.split(" ") : []).forEach((a) => {
      if (a.startsWith("atm_")) {
        const [, l] = a.split("_");
        r[l] = a;
      } else
        n.push(a);
    });
  });
  const o = [];
  for (const s in r)
    Object.prototype.hasOwnProperty.call(r, s) && o.push(r[s]);
  return o.push(...n), o.join(" ");
}, B = qe, He = (e) => e.toUpperCase() === e, Ke = (e) => (t) => e.indexOf(t) === -1, ne = (e, t) => {
  const r = {};
  return Object.keys(e).filter(Ke(t)).forEach((n) => {
    r[n] = e[n];
  }), r;
};
function Be(e, t, r) {
  const n = ne(t, r);
  if (!e) {
    const o = typeof U == "function" ? { default: U } : U;
    Object.keys(n).forEach((s) => {
      o.default(s) || delete n[s];
    });
  }
  return n;
}
var ze = (e, t) => {
  if (process.env.NODE_ENV !== "production") {
    if (typeof e == "string" || // eslint-disable-next-line no-self-compare,no-restricted-globals
    typeof e == "number" && isFinite(e))
      return;
    const r = typeof e == "object" ? JSON.stringify(e) : String(e);
    console.warn(
      `An interpolation evaluated to '${r}' in the component '${t}', which is probably a mistake. You should explicitly cast or transform the value to a string.`
    );
  }
}, We = 0;
function z(e) {
  let t = "";
  return process.env.NODE_ENV === "test" && (t += `mocked-styled-${We++}`, e && e.__wyw_meta && e.__wyw_meta.className && (t += ` ${e.__wyw_meta.className}`)), (r) => {
    if (process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && Array.isArray(r))
      throw new Error(
        'Using the "styled" tag in runtime is not supported. Make sure you have set up the Babel plugin correctly. See https://github.com/callstack/linaria#setup'
      );
    const n = (s, i) => {
      const { as: a = e, class: l = t } = s, u = r.propsAsIs === void 0 ? !(typeof a == "string" && a.indexOf("-") === -1 && !He(a[0])) : r.propsAsIs, d = Be(u, s, [
        "as",
        "class"
      ]);
      d.ref = i, d.className = r.atomic ? B(r.class, d.className || l) : B(d.className || l, r.class);
      const { vars: g } = r;
      if (g) {
        const h = {};
        for (const p in g) {
          const m = g[p], b = m[0], _ = m[1] || "", c = typeof b == "function" ? b(s) : b;
          ze(c, r.name), h[`--${p}`] = `${c}${_}`;
        }
        const f = d.style || {}, y = Object.keys(f);
        y.length > 0 && y.forEach((p) => {
          h[p] = f[p];
        }), d.style = h;
      }
      return e.__wyw_meta && e !== a ? (d.as = a, D(e, d)) : D(a, d);
    }, o = H ? H(n) : (
      // React.forwardRef won't available on older React versions and in Preact
      // Fallback to a innerRef prop in that case
      (s) => {
        const i = ne(s, ["innerRef"]);
        return n(i, s.innerRef);
      }
    );
    return o.displayName = r.name, o.__wyw_meta = {
      className: r.class || t,
      extends: e
    }, o;
  };
}
var S = process.env.NODE_ENV !== "production" ? new Proxy(z, {
  get(e, t) {
    return e(t);
  }
}) : z;
function Ve(e) {
  const t = +("0x" + (e == null ? void 0 : e.slice(1).replace(e.length < 5 ? /./g : "", "$&$&"))), r = t >> 16, n = t >> 8 & 255, o = t & 255;
  return Math.sqrt(0.299 * (r * r) + 0.587 * (n * n) + 0.114 * (o * o)) > 127.5 ? "dark" : "light";
}
const Je = /* @__PURE__ */ S("div")({
  name: "CardContent",
  class: "CardContent_cene200",
  propsAsIs: !1
}), Xe = /* @__PURE__ */ S("div")({
  name: "Heading",
  class: "Heading_h1ag0jg5",
  propsAsIs: !1
}), Ge = /* @__PURE__ */ S("div")({
  name: "LogoContainer",
  class: "LogoContainer_lf8nb76",
  propsAsIs: !1
}), Qe = () => (e) => e.color, Ye = () => (e) => Ve(e.color) === "light" ? "white" : "black", oe = /* @__PURE__ */ S("div")({
  name: "Card",
  class: "Card_cn7bqld",
  propsAsIs: !1,
  vars: {
    "cn7bqld-0": [Qe()],
    "cn7bqld-1": [Ye()]
  }
}), Ze = () => oe, et = /* @__PURE__ */ S(Ze())({
  name: "DefaultCard",
  class: "DefaultCard_diw1l80",
  propsAsIs: !0
}), tt = () => oe, rt = /* @__PURE__ */ S(tt())({
  name: "AutohideCard",
  class: "AutohideCard_ackent1",
  propsAsIs: !0
}), F = ({ variant: e }) => e === "autohide";
const nt = () => (e) => F(e) ? "initial" : "none", ot = () => (e) => F(e) ? "initial" : `'${e.ctaLabel}'`, st = /* @__PURE__ */ S("div")({
  name: "Cta",
  class: "Cta_cbylxvg",
  propsAsIs: !1,
  vars: {
    "cbylxvg-0": [nt()],
    "cbylxvg-1": [ot()]
  }
});
const it = /* @__PURE__ */ S("div")({
  name: "Text",
  class: "Text_t1gpznzf",
  propsAsIs: !1
}), at = (e) => {
  switch (e) {
    case "autohide":
      return rt;
    case "default":
    default:
      return et;
  }
}, ct = (e) => Array.isArray(e) ? e.length ? e.join(" ") : null : e ?? null, lt = ({ fallback: e, key: t, translatorFunction: r }) => {
  const n = r(t);
  return n === t ? e : n;
}, ut = ({
  color: e,
  ctaText: t,
  disabled: r,
  heading: n,
  id: o,
  label: s,
  logoAlt: i,
  logoUrl: a,
  onClick: l,
  text: u,
  variant: d
}) => {
  const g = at(d), h = ct(s), f = Ne(a), { t: y } = Ae(), p = lt({ fallback: "CLAIM", key: "CX_CLAIM_OFFER_CTA", translatorFunction: y });
  return /* @__PURE__ */ C(g, { color: e, "data-height": `${n} !!`, "data-testid": "offer-card", children: /* @__PURE__ */ I(Je, { "data-offer-id": o, children: [
    /* @__PURE__ */ I(Ge, { children: [
      /* @__PURE__ */ C("img", { alt: i, src: f }),
      h && /* @__PURE__ */ C("span", { children: h })
    ] }),
    /* @__PURE__ */ I(Xe, { children: [
      n,
      /* @__PURE__ */ C(N, {})
    ] }),
    u ? /* @__PURE__ */ C(it, { dangerouslySetInnerHTML: { __html: u } }) : null,
    r ? null : /* @__PURE__ */ C(st, { ctaLabel: p, variant: d, children: /* @__PURE__ */ C(
      "button",
      {
        onClick: (m) => {
          m.preventDefault(), l(m);
        },
        children: /* @__PURE__ */ C("span", { children: t })
      }
    ) })
  ] }) });
}, W = typeof window < "u";
function ft(e, t) {
  const r = W ? new IntersectionObserver(([n]) => {
    n.isIntersecting && (t && t(), r == null || r.disconnect());
  }) : null;
  ye(() => {
    W && e.current && r && r.observe(e.current);
  }, [e]);
}
const $ = /{{([^{{}}]*)}}/g, dt = (e) => e.replace(/[ /-]+/g, "_").replace(/[^a-zA-Z0-9_]/g, "").replace(/_+/g, "_").toUpperCase(), pt = ({ marketName: e, t }) => {
  const n = `CX_MARKET_TYPE_${dt(e)}`, o = t(n, { ns: "label" });
  return o === n ? e : o;
}, ht = (e) => {
  const t = e.match(new RegExp("(?<=\\s)(at\\.|vs\\.?|@|v\\.?|at)(?=\\s)", "i"));
  if (!t)
    return null;
  const r = t[1], n = e.split(new RegExp(`\\s${r.replace(".", "\\.")}\\s`, "i")).map((o) => o.trim());
  return n.length === 2 ? { parts: n, separator: r } : null;
}, mt = (e, t, r) => typeof e != "string" ? "" : t == null || typeof t != "object" ? e : RegExp($.source).test(e) ? e.replace($, (n, o) => {
  const s = o.trim().split(/\./);
  let i = t;
  for (let a = 0; a < s.length; a += 1) {
    if (i[s[a]] == null)
      return n;
    i = i[s[a]];
  }
  if (typeof i == "string") {
    const { SPORT: a = "" } = t, l = a == null ? void 0 : a.toLowerCase();
    switch (s[0]) {
      case "EVENT":
        return !l || !r ? i : r(i, {
          ns: l
        });
      case "MARKET":
        return r ? pt({
          marketName: i,
          t: r
        }) : i;
      case "SPORT":
        return r ? r(K(i), {
          ns: "label"
        }) : i;
      case "SUBEVENT": {
        const u = ht(i);
        if (u) {
          const [d, g] = u.parts.map((f) => r ? r(f ? K(f) : "", {
            ns: l
          }) : f);
          return `${d} ${u.separator} ${g}`;
        }
        return i;
      }
      default:
        return i;
    }
  }
  return n;
}) : e, se = (e = "") => {
  if (typeof e != "string" || !e.trim())
    return {};
  const t = "|", r = e.split(t).map((n) => n.trim().split("=").map((o) => o.trim()));
  return Object.fromEntries(r);
}, yt = ({
  fallbackString: e = "",
  placeholdersString: t,
  subjectString: r,
  translatorFunction: n
}) => {
  const o = se(t), s = mt(r, o, n);
  return RegExp($.source).test(s) && e || s;
}, V = ({
  placeholders: e,
  template: t = "",
  translatorFunction: r,
  value: n = ""
}) => !t || !e ? n : n && yt({
  fallbackString: n.trim(),
  placeholdersString: e,
  subjectString: t.trim(),
  translatorFunction: r
}), gt = (e) => {
  if (!e)
    return;
  const t = se(e), r = Object.keys(t);
  return r.length ? [
    ...new Set(
      r.map((n) => {
        var o;
        switch (n) {
          case "SUBEVENT":
          case "EVENT":
            return (o = t.SPORT) == null ? void 0 : o.toLowerCase();
          case "SPORT":
          case "MARKET":
            return "label";
          default:
            return;
        }
      }).filter((n) => n !== void 0)
    )
  ] : e;
}, vt = "application/json", ie = "Content-Type", R = Symbol(), ae = Symbol();
function J(e = {}) {
  var t;
  const r = e instanceof Array ? Object.fromEntries(e) : e;
  return (t = Object.entries(r).find(([n]) => n.toLowerCase() === ie.toLowerCase())) === null || t === void 0 ? void 0 : t[1];
}
function X(e) {
  return /^application\/.*json.*/.test(e);
}
const L = function(e, t, r = !1) {
  return Object.entries(t).reduce((n, [o, s]) => {
    const i = e[o];
    return Array.isArray(i) && Array.isArray(s) ? n[o] = r ? [...i, ...s] : s : typeof i == "object" && typeof s == "object" ? n[o] = L(i, s, r) : n[o] = s, n;
  }, { ...e });
}, P = {
  // Default options
  options: {},
  // Error type
  errorType: "text",
  // Polyfills
  polyfills: {
    // fetch: null,
    // FormData: null,
    // URL: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null,
  },
  polyfill(e, t = !0, r = !1, ...n) {
    const o = this.polyfills[e] || (typeof self < "u" ? self[e] : null) || (typeof global < "u" ? global[e] : null);
    if (t && !o)
      throw new Error(e + " is not defined");
    return r && o ? new o(...n) : o;
  }
};
function bt(e, t = !1) {
  P.options = t ? e : L(P.options, e);
}
function wt(e, t = !1) {
  P.polyfills = t ? e : L(P.polyfills, e);
}
function Ct(e) {
  P.errorType = e;
}
const _t = (e) => (t) => e.reduceRight((r, n) => n(r), t) || t;
class ce extends Error {
}
const Et = (e) => {
  const t = /* @__PURE__ */ Object.create(null);
  e = e._addons.reduce((c, v) => v.beforeRequest && v.beforeRequest(c, e._options, t) || c, e);
  const { _url: r, _options: n, _config: o, _catchers: s, _resolvers: i, _middlewares: a, _addons: l } = e, u = new Map(s), d = L(o.options, n);
  let g = r;
  const h = _t(a)((c, v) => (g = c, o.polyfill("fetch")(c, v)))(r, d), f = new Error(), y = h.catch((c) => {
    throw { [R]: c };
  }).then((c) => {
    var v;
    if (!c.ok) {
      const w = new ce();
      if (w.cause = f, w.stack = w.stack + `
CAUSE: ` + f.stack, w.response = c, w.status = c.status, w.url = g, c.type === "opaque")
        throw w;
      const k = o.errorType === "json" || ((v = c.headers.get("Content-Type")) === null || v === void 0 ? void 0 : v.split(";")[0]) === "application/json";
      return (o.errorType ? k ? c.text() : c[o.errorType]() : Promise.resolve(c.body)).then((E) => {
        throw w.message = typeof E == "string" ? E : c.statusText, E && (k && typeof E == "string" ? (w.text = E, w.json = JSON.parse(E)) : w[o.errorType] = E), w;
      });
    }
    return c;
  }), p = (c) => c.catch((v) => {
    const w = Object.prototype.hasOwnProperty.call(v, R), k = w ? v[R] : v, O = (k == null ? void 0 : k.status) && u.get(k.status) || u.get(k == null ? void 0 : k.name) || w && u.has(R) && u.get(R);
    if (O)
      return O(k, e);
    const E = u.get(ae);
    if (E)
      return E(k, e);
    throw k;
  }), m = (c) => (v) => /* If a callback is provided, then callback with the body result otherwise return the parsed body itself. */ p(c ? y.then((w) => w && w[c]()).then((w) => v ? v(w) : w) : y.then((w) => v ? v(w) : w)), b = {
    _wretchReq: e,
    _fetchReq: h,
    _sharedState: t,
    res: m(null),
    json: m("json"),
    blob: m("blob"),
    formData: m("formData"),
    arrayBuffer: m("arrayBuffer"),
    text: m("text"),
    error(c, v) {
      return u.set(c, v), this;
    },
    badRequest(c) {
      return this.error(400, c);
    },
    unauthorized(c) {
      return this.error(401, c);
    },
    forbidden(c) {
      return this.error(403, c);
    },
    notFound(c) {
      return this.error(404, c);
    },
    timeout(c) {
      return this.error(408, c);
    },
    internalError(c) {
      return this.error(500, c);
    },
    fetchError(c) {
      return this.error(R, c);
    }
  }, _ = l.reduce((c, v) => ({
    ...c,
    ...typeof v.resolver == "function" ? v.resolver(c) : v.resolver
  }), b);
  return i.reduce((c, v) => v(c, e), _);
}, kt = {
  _url: "",
  _options: {},
  _config: P,
  _catchers: /* @__PURE__ */ new Map(),
  _resolvers: [],
  _deferred: [],
  _middlewares: [],
  _addons: [],
  addon(e) {
    return { ...this, _addons: [...this._addons, e], ...e.wretch };
  },
  errorType(e) {
    return {
      ...this,
      _config: {
        ...this._config,
        errorType: e
      }
    };
  },
  polyfills(e, t = !1) {
    return {
      ...this,
      _config: {
        ...this._config,
        polyfills: t ? e : L(this._config.polyfills, e)
      }
    };
  },
  url(e, t = !1) {
    if (t)
      return { ...this, _url: e };
    const r = this._url.split("?");
    return {
      ...this,
      _url: r.length > 1 ? r[0] + e + "?" + r[1] : this._url + e
    };
  },
  options(e, t = !1) {
    return { ...this, _options: t ? e : L(this._options, e) };
  },
  headers(e) {
    const t = e ? Array.isArray(e) ? Object.fromEntries(e) : "entries" in e ? Object.fromEntries(e.entries()) : e : {};
    return { ...this, _options: L(this._options, { headers: t }) };
  },
  accept(e) {
    return this.headers({ Accept: e });
  },
  content(e) {
    return this.headers({ [ie]: e });
  },
  auth(e) {
    return this.headers({ Authorization: e });
  },
  catcher(e, t) {
    const r = new Map(this._catchers);
    return r.set(e, t), { ...this, _catchers: r };
  },
  catcherFallback(e) {
    return this.catcher(ae, e);
  },
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  resolve(e, t = !1) {
    return { ...this, _resolvers: t ? [e] : [...this._resolvers, e] };
  },
  defer(e, t = !1) {
    return {
      ...this,
      _deferred: t ? [e] : [...this._deferred, e]
    };
  },
  middlewares(e, t = !1) {
    return {
      ...this,
      _middlewares: t ? e : [...this._middlewares, ...e]
    };
  },
  fetch(e = this._options.method, t = "", r = null) {
    let n = this.url(t).options({ method: e });
    const o = J(n._options.headers), s = this._config.polyfill("FormData", !1), i = typeof r == "object" && !(s && r instanceof s) && (!n._options.headers || !o || X(o));
    return n = r ? i ? n.json(r, o) : n.body(r) : n, Et(n._deferred.reduce((a, l) => l(a, a._url, a._options), n));
  },
  get(e = "") {
    return this.fetch("GET", e);
  },
  delete(e = "") {
    return this.fetch("DELETE", e);
  },
  put(e, t = "") {
    return this.fetch("PUT", t, e);
  },
  post(e, t = "") {
    return this.fetch("POST", t, e);
  },
  patch(e, t = "") {
    return this.fetch("PATCH", t, e);
  },
  head(e = "") {
    return this.fetch("HEAD", e);
  },
  opts(e = "") {
    return this.fetch("OPTIONS", e);
  },
  body(e) {
    return { ...this, _options: { ...this._options, body: e } };
  },
  json(e, t) {
    const r = J(this._options.headers);
    return this.content(t || X(r) && r || vt).body(JSON.stringify(e));
  }
};
function A(e = "", t = {}) {
  return { ...kt, _url: e, _options: t };
}
A.default = A;
A.options = bt;
A.errorType = Ct;
A.polyfills = wt;
A.WretchError = ce;
class xt extends Error {
  constructor(r, n, o, s, i) {
    super(r);
    T(this, "statusCode");
    T(this, "endpoint");
    T(this, "args");
    T(this, "response");
    this.name = "ApiError", this.statusCode = n, this.endpoint = o, this.args = s, this.response = i;
  }
}
class q extends xt {
  constructor(t, r, n, o) {
    super(`Client error ${t} occurred while fetching ${r}`, t, r, n, o), this.name = "Api4xxError";
  }
}
class Tt extends q {
  constructor(t, r, n) {
    super(404, t, r, n), this.name = "Api404Error";
  }
}
class At extends q {
  constructor(t, r, n) {
    super(400, t, r, n), this.name = "Api400Error";
  }
}
class St {
  constructor(t = {}) {
    T(this, "logger");
    T(this, "notFoundLogLevel");
    T(this, "badRequestLogLevel");
    T(this, "other4xxLogLevel");
    this.logger = t.logger, this.notFoundLogLevel = t.notFoundLogLevel || "info", this.badRequestLogLevel = t.badRequestLogLevel || "warn", this.other4xxLogLevel = t.other4xxLogLevel || "warn";
  }
  log(t, r, n) {
    this.logger && this.logger[t](r, n);
  }
  async handleApiError(t, r, n) {
    if (!(t instanceof Response))
      throw t;
    const { status: o } = t;
    if (o === 404) {
      const s = new Tt(r, n, t);
      return this.log(this.notFoundLogLevel, s.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    if (o === 400) {
      const s = new At(r, n, t);
      return this.log(this.badRequestLogLevel, s.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    if (o >= 400 && o < 500) {
      const s = new q(o, r, n, t);
      return this.log(this.other4xxLogLevel, s.message, {
        args: n,
        endpoint: r,
        statusCode: o
      }), null;
    }
    throw t;
  }
}
const Ot = (e, t) => {
  const r = new St(t);
  return e.catcher(404, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(400, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(401, async (n) => (await r.handleApiError(n.response, n.url), null)).catcher(403, async (n) => (await r.handleApiError(n.response, n.url), null)).catcherFallback(async (n) => {
    if (n.status >= 400 && n.status < 500)
      return await r.handleApiError(n.response, n.url), null;
    throw n;
  });
}, Lt = (e) => e ? e.split(",").map((t) => t.trim()).filter(Boolean).join(",") : "", Rt = (e) => {
  const t = Object.entries(e).filter(([, r]) => r !== void 0).sort(([r], [n]) => r.localeCompare(n)).map(([r, n]) => [r, String(n)]);
  return new URLSearchParams(t).toString();
}, Pt = async (e, t, r) => {
  var p;
  const { apiKey: n, countryCode: o, deviceType: s, offerIds: i, offerLimit: a, sortBy: l, subdivisionCode: u, vcId: d } = t;
  if (!n)
    throw (p = r == null ? void 0 : r.logger) == null || p.error("No apiKey provided"), new Error("No apiKey provided.");
  const g = d ? { variationContainerId: d } : i ? { offerIds: Lt(i) } : void 0, h = Rt({
    ...g,
    ...s && { deviceType: s },
    ...a ? { limit: a } : {},
    ...l ? { sort: l } : {}
  }), f = new URL(`${e}/v1/offers?${h}`);
  return Ot(
    A(f.toString(), {
      headers: {
        accept: "application/json",
        "api-key": n,
        "content-type": "application/json",
        ...o && { "country-code": o },
        ...u && { "subdivision-code": u },
        ...(r == null ? void 0 : r.nocache) && { "Cache-Control": "no-cache" }
      }
    }),
    r
  ).get().json();
}, le = async (e = "https://offers-delivery-api-stg.core.occloud.io", t, r = {}) => {
  try {
    return await Pt(e, t, r);
  } catch (n) {
    throw r.logger && r.logger.error(n), n;
  }
}, ue = ({
  apiKey: e,
  countryCode: t,
  offerIds: r,
  offerLimit: n,
  sortBy: o,
  subdivisionCode: s,
  vcId: i
}) => ["offers-slim", e, r, i, t, s, n, o], jt = (e) => e && e.map((t) => {
  var r, n;
  return "code" in t.bookmaker && typeof t.bookmaker.code == "string" && (t.bookmaker.feedsCode = t.bookmaker.code, delete t.bookmaker.code), "clickoutUrl" in t && typeof ((r = t.clickoutUrl) == null ? void 0 : r.url) == "string" && (t.clickOutUrl = (n = t.clickoutUrl) == null ? void 0 : n.url, delete t.clickoutUrl), "isTermsExpanded" in t && typeof t.isTermsExpanded == "boolean" && (t.autoExpandedTermsAndConditions = t.isTermsExpanded, delete t.isTermsExpanded), t;
}), It = ({
  dataApiEndpoint: e,
  ...t
}) => we({
  queryFn: () => le(e, t, {
    logger: console
  }),
  queryKey: ue(t),
  select: (r) => jt(r)
}), Ut = (e, t, r) => {
  e.push({
    action: "offers_clickout",
    bookieCode: t.bookie,
    category: "Widget",
    event: "offer_clickouts",
    label: "claim_offer",
    offerIndex: r + 1,
    offerName: t.heading,
    page: window.location.href,
    variation: "horizontal-slim"
  });
}, Dt = (e, t) => {
  e.push({
    action: "impression",
    category: "Widget",
    event: "widget_impression",
    label: "widget_impression",
    page: window.location.href,
    variation: "horizontal-slim",
    widgetType: "offers",
    ...t ?? {}
  });
}, Mt = ({
  bookmaker: e,
  bookmakerCode: t,
  clickOutUrl: r,
  clickoutUrl: n,
  displayTitle: o,
  displayTitleTemplate: s,
  featuredLabels: i,
  fullTerms: a,
  id: l,
  offerCta: u,
  offerCtaTemplate: d,
  shortTerms: g
}, { placeholders: h, translation: f, variant: y }) => {
  var c;
  const p = r || (n == null ? void 0 : n.url), m = V({
    placeholders: h,
    template: d,
    translatorFunction: f,
    value: u
  }), b = V({
    placeholders: h,
    template: s,
    translatorFunction: f,
    value: o
  }), _ = F({ variant: y }) && !m || !p;
  return {
    bookie: t,
    color: e.primaryColor,
    ctaText: m,
    disabled: _,
    heading: b,
    id: l,
    label: i ?? void 0,
    logoAlt: e.name || t,
    logoUrl: (c = e.logoFull) == null ? void 0 : c.url,
    text: y === "autohide" ? a : g ? `<p>${g}</p>` : void 0,
    url: p,
    variant: y ?? "default"
  };
}, Nt = (e, t) => (e || []).map((r) => Mt(r, t));
const $t = /* @__PURE__ */ S("div")({
  name: "Theme",
  class: "Theme_t4ho7n3",
  propsAsIs: !1
}), Ft = () => typeof window < "u" ? window.dataLayer : [], qt = (e) => {
  const {
    analyticsDataLayer: t = Ft(),
    analyticsImpressionEventData: r,
    apiKey: n,
    clickoutService: o = "OFFERS_CLICKOUT_SERVICE",
    clickoutServiceUrl: s,
    deviceType: i = "desktop",
    disableAnalytics: a,
    fullPageUrl: l,
    gtmId: u = null,
    pageUrl: d,
    placeholders: g,
    recommendedMarketId: h,
    variant: f
  } = e, { data: y } = It(e), p = Array.isArray(y) && y.length > 0, m = f || "default", _ = Re({
    apiKey: n,
    clickoutOrigin: "offers-slim",
    clickoutServiceUrl: s,
    deviceType: i,
    fullPageUrl: l,
    gtmId: u,
    offers: y,
    pageUrl: d,
    recommendedMarketId: h,
    shouldUseClickoutService: o === "OFFERS_CLICKOUT_SERVICE"
  }), c = gt(g), { t: v } = re(c ?? ["label", "football"]), w = te(null);
  ft(w, () => {
    a || Dt(t, r || {});
  });
  const k = (O, E) => {
    a || Ut(t, E, O), window.open(E.url, "_blank", "noopener noreferrer");
  };
  return /* @__PURE__ */ C($t, { "data-testid": "offers-slim", ref: w, children: p && /* @__PURE__ */ C(Me, { variant: m, children: Nt(_, {
    placeholders: g,
    translation: v,
    variant: m
  }).map((O, E) => /* @__PURE__ */ D(ut, { ...O, key: E, onClick: () => k(E, O), variant: m })) }) });
};
var Ht = typeof x == "object" && x && x.Object === Object && x, Kt = typeof self == "object" && self && self.Object === Object && self, Bt = Ht || Kt || Function("return this")(), G = Bt.Symbol, Q = G ? G.prototype : void 0;
Q && Q.toString;
var zt = typeof x == "object" && x && x.Object === Object && x, Wt = typeof self == "object" && self && self.Object === Object && self, Vt = zt || Wt || Function("return this")(), Y = Vt.Symbol, Z = Y ? Y.prototype : void 0;
Z && Z.toString;
(function(e) {
  typeof globalThis != "object" && (this ? t() : (e.defineProperty(e.prototype, "_T_", {
    configurable: !0,
    get: t
  }), _T_));
  function t() {
    var r = this || self;
    r.globalThis = r, delete e.prototype._T_;
  }
})(Object);
const Jt = (e, t) => t.skipDedupe || t.method !== "GET", Xt = (e, t) => t.method + "@" + e, Gt = (e) => e.clone(), fe = ({ skip: e = Jt, key: t = Xt, resolver: r = Gt } = {}) => {
  const n = /* @__PURE__ */ new Map();
  return (o) => (s, i) => {
    if (e(s, i))
      return o(s, i);
    const a = t(s, i);
    if (!n.has(a))
      n.set(a, []);
    else
      return new Promise((l, u) => {
        n.get(a).push([l, u]);
      });
    try {
      return o(s, i).then((l) => (n.get(a).forEach(([u]) => u(r(l))), n.delete(a), l)).catch((l) => {
        throw n.get(a).forEach(([, u]) => u(l)), n.delete(a), l;
      });
    } catch (l) {
      return n.delete(a), Promise.reject(l);
    }
  };
}, Qt = (e, t) => t.skipCache || t.method !== "GET", Yt = (e, t) => t.method + "@" + e, Zt = () => !1, er = () => null, tr = (e) => e.ok, rr = ({ throttle: e = 1e3, skip: t = Qt, key: r = Yt, clear: n = Zt, invalidate: o = er, condition: s = tr, flagResponseOnCacheHit: i = "__cached" } = {}) => {
  const a = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), u = /* @__PURE__ */ new Set(), d = (h) => {
    e && !u.has(h) && (u.add(h), setTimeout(() => {
      u.delete(h);
    }, e));
  }, g = (h) => (f, y) => {
    const p = r(f, y);
    let m = o(f, y);
    if (m && (m instanceof Array || (m = [m]), m.forEach((b) => {
      typeof b == "string" ? a.delete(b) : b instanceof RegExp && a.forEach((_, c) => {
        b.test(c) && a.delete(c);
      });
    })), n(f, y) && a.clear(), t(f, y))
      return h(f, y);
    if (u.has(p)) {
      if (a.has(p)) {
        const b = a.get(p).clone();
        return i && Object.defineProperty(b, i, {
          value: p,
          enumerable: !1
        }), Promise.resolve(b);
      } else if (l.has(p))
        return new Promise((b, _) => {
          l.get(p).push([b, _]);
        });
    }
    return l.has(p) || l.set(p, []), d(p), h(f, y).then((b) => (s(b.clone()) && a.set(p, b.clone()), l.get(p).forEach(([_]) => _(b.clone())), l.delete(p), b)).catch((b) => {
      throw l.get(p).forEach(([, _]) => _(b)), l.delete(p), b;
    });
  };
  return g.cacheResponse = function(h, f) {
    d(h), a.set(h, f);
  }, g.cache = a, g.inflight = l, g.throttling = u, g;
}, nr = (e, t) => e * t, or = (e) => e && e.ok, de = ({ delayTimer: e = 500, delayRamp: t = nr, maxAttempts: r = 10, until: n = or, onRetry: o = null, retryOnNetworkError: s = !1, resolveWithLatestResponse: i = !1, skip: a } = {}) => (l) => (u, d) => {
  let g = 0;
  if (a && a(u, d))
    return l(u, d);
  const h = (f, y) => Promise.resolve(n(f, y)).then((p) => p ? f && i ? f : y ? Promise.reject(y) : f : (g++, !r || g <= r ? new Promise((m) => {
    const b = t(e, g);
    setTimeout(() => {
      typeof o == "function" ? Promise.resolve(o({
        response: f,
        error: y,
        url: u,
        options: d
      })).then((_ = {}) => {
        var c, v;
        m(l((c = _ && _.url) !== null && c !== void 0 ? c : u, (v = _ && _.options) !== null && v !== void 0 ? v : d));
      }) : m(l(u, d));
    }, b);
  }).then(h).catch((m) => {
    if (!s)
      throw m;
    return h(null, m);
  }) : f && i ? f : Promise.reject(y || new Error("Number of attempts exceeded."))));
  return l(u, d).then(h).catch((f) => {
    if (!s)
      throw f;
    return h(null, f);
  });
};
A().middlewares([
  fe(),
  de({
    delayRamp: (e, t) => e * t,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  }),
  rr({
    key: (e, t) => t.headers["X-Cache-Key"],
    throttle: 1e3 * 60 * 60 * 24 * 7
    // 7 days (max safe is ~24.8 days)
  })
]);
A().middlewares([
  fe(),
  de({
    delayRamp: (e, t) => e * t,
    delayTimer: 100,
    maxAttempts: 3,
    resolveWithLatestResponse: !1
  })
]);
function sr(e = {}) {
  return new be.QueryClient({
    defaultOptions: {
      queries: {
        retry: 3,
        retryDelay(t) {
          return t * 100;
        }
      }
    },
    ...e
  });
}
const pr = async (e, t) => {
  const r = sr();
  try {
    await r.prefetchQuery({
      queryFn: () => le(t, e, { nocache: e.nocache }),
      queryKey: ue(e)
    });
  } catch {
  }
  return {
    dehydratedState: Ce(r)
  };
}, ir = (e) => new ke({
  defaultOptions: {
    queries: {
      gcTime: e ? 0 : void 0,
      refetchOnMount: !!e,
      staleTime: e ? 0 : 1 / 0
    }
  }
});
function hr({ dehydratedState: e, loadingSlot: t, nocache: r, ...n }) {
  const [o] = ge(() => {
    const s = ir(r);
    return _e(s, e), s;
  });
  return /* @__PURE__ */ C(Ee, { client: o, children: /* @__PURE__ */ C(Te, { i18nInstance: n.i18n, children: /* @__PURE__ */ C(ve, { fallback: t ?? /* @__PURE__ */ C("div", { children: "Loading..." }), children: /* @__PURE__ */ C(qt, { ...n }) }) }) });
}
export {
  hr as default,
  pr as loadDataForServer
};
//# sourceMappingURL=index.es.js.map
